import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Button from '../../../shared/Button/Button';
import RadioContainer from '../../../shared/FormFields/RadioContainer';
import { css } from '@emotion/core';
import { FaSpinner } from 'react-icons/fa';
import {
  setPaymentType,
  createOrder,
} from '../../../../redux/modules/checkout';
import {
  getCartTotalWithExpenses,
  getCartTotalDiscountedCoupon,
} from '../../../../redux/modules/cart';
import Price from '../../../shared/Price/Price';
import {
  checkoutStep,
  checkoutStepOptionEvent,
} from '../../../shared/lib/gaEnhancedEcommerce';
import CarteNexiOneLine from '../../../shared/Icons/CarteNexiOneLine';
import './Pagamento.scss';
import { getAuthHeaders, getHeaders } from '../../../../api';
import Config from '../../../../config';
import { ga4AddPaymentInfo } from '../../../shared/lib/ga4EnhancedEcommerce';
import { fkmxAddPaymentInfo } from '../../../shared/lib/farmakomMetrics';
import { gtmToGa4AddPaymentInfo } from '../../../shared/lib/gtmEnhancedEcommerce';

const apiUrl =
  (Config.useDevApi ? Config.devApiBaseHost : Config.apiBaseHost) +
  Config.apiBasePath;
class Pagamento extends Component {
  constructor(props) {
    super(props);

    this.state = {
      savingOrder: false,
      withRicetta: false,
      paypalBoxHeight: 100,
    };
  }

  ///////////////////////////////////
  // GOOGLE ANALYTICS STEP 4
  gaStep4(cart) {
    const productsGA = cart.map(p => ({
      id: p.code || '',
      name: p.name,
      category: p.categoryName,
      brand: p.brand,
      price: p.price,
      quantity: p.quantity,
    }));
    // SEND EVENT AFTER 1 SEC
    setTimeout(() => {
      checkoutStep(productsGA, 4);
    }, 1000);
  }

  componentDidMount() {
    const { user, checkout } = this.props;

    // rimuovo il componente per permettere il pagamento tramite ospite

    if (!checkout.doneShipping) {
      this.props.router.push('/carrello');
    }

    // GOOGLE ANALYTICS STEP 4
    if (this.props.advancedGa && this.props.cart) {
      this.gaStep4(this.props.cart);
    }

    // CHECK IF PRODUCT WITH RICETTA
    this.setState({
      withRicetta: this.props.cart.find(product => !!product.prescription),
    });

    // if (!!user.authenticated && !!checkout.doneShipping) {
    if (!!checkout.doneShipping) {
      if (!!this.props.hasPaypalAdvanced) {
        this.loadPaypalAdvancedScript();
      }
      if (!!this.props.hasPaypalPayIn3) {
        this.loadPaypalPayIn3Script();
      }
    }

    // Set is mobile & paypal box height
    this.setState({
      paypalBoxHeight:
        ((!!document &&
          !!document.getElementById('payload_advanced_box') &&
          document.getElementById('payload_advanced_box').offsetHeight) ||
          0) + 50,
    });
  }

  componentWillReceiveProps(nextProps) {
    // GOOGLE ANALYTICS STEP 4
    if (nextProps.advancedGa && nextProps.cart !== this.props.cart) {
      this.gaStep4(nextProps.cart);
    }
  }

  componentDidUpdate(oldProps) {
    if (oldProps.checkout.paymentType !== this.props.checkout.paymentType) {
      if (
        this.props.checkout.paymentType === 'paypal_pay_in_3' &&
        !!window.paypal
      ) {
        this._renderPaypalPayLaterMessage(100);
        // multiple times because somebrowser takes more time
        // but we still want to show it as soon as we can
        this._renderPaypalPayLaterMessage(250);
        this._renderPaypalPayLaterMessage(500);
      }
    }
  }

  _renderPaypalPayLaterMessage = ms => {
    setTimeout(() => {
      window.paypal
        .Messages({
          amount: this.props.cartTotalWithExpenses,
          placement: 'payment',
        })
        .render('#pp-pay-later-message');
    }, ms);
  };

  loadPaypalAdvancedScript = () => {
    if (typeof window !== 'undefined' && !!window.paypal) {
      const { checkout, user, storeId, cartTotalWithExpenses } = this.props;

      const headers = checkout.guestCheckout
        ? JSON.stringify(getHeaders(true))
        : JSON.stringify(getAuthHeaders());

      // Render the button component
      paypal
        .Buttons({
          // Sets up the transaction when a payment button is clicked
          createOrder: createOrderCallback,
          onApprove: onApproveCallback,
          onCancel: onCancelCallback,
          onError: function(error) {
            // Do something with the error from the SDK
          },
          style: {
            shape: 'rect',
            layout: 'vertical',
            color: 'gold',
            label: 'paypal',
          },
          message: {
            amount: cartTotalWithExpenses,
          },
        })
        .render('#paypal-button-container');

      // Render each field after checking for eligibility
      const cardField = window.paypal.CardFields({
        createOrder: createOrderCallback,
        onApprove: onApproveCallback,
        style: {
          input: {
            'font-size': '16px',
            'font-family': 'courier, monospace',
            'font-weight': 'lighter',
            color: '#ccc',
          },
          '.invalid': { color: 'red' },
        },
      });

      if (cardField.isEligible()) {
        const nameField = cardField.NameField({
          placeholder: 'Mario Rossi',
          style: { input: { color: 'blue' }, '.invalid': { color: 'purple' } },
        });
        nameField.render('#card-name-field-container');

        const numberField = cardField.NumberField({
          placeholder: '4005 5192 0000 0004',
          style: { input: { color: 'blue' } },
        });
        numberField.render('#card-number-field-container');

        const cvvField = cardField.CVVField({
          placeholder: 'CVV',
          style: { input: { color: 'blue' } },
        });
        cvvField.render('#card-cvv-field-container');

        const expiryField = cardField.ExpiryField({
          placeholder: 'MM/AA',
          style: { input: { color: 'blue' } },
        });
        expiryField.render('#card-expiry-field-container');

        // Add click listener to submit button and call the submit function on the CardField component
        document
          .getElementById('card-field-submit-button')
          .addEventListener('click', () => {
            cardField
              .submit({
                // From your billing address fields
                billingAddress: {
                  addressLine1: user.data.billing.address1,
                  addressLine2: user.data.billing.address2,
                  adminArea1: user.data.billing.province,
                  adminArea2: user.data.billing.city,
                  countryCode: 'IT',
                  postalCode: user.data.billing.zipcode,
                },
                contingencies: ['SCA_WHEN_REQUIRED'],
              })
              .then(() => {
                // Submitted...
              });
          });
      } else {
        // Hides card fields if the merchant isn't eligible
        document.querySelector('#card-form').style = 'display: none';
      }

      const prepareOrder = () => {
        const order = {
          cartId: localStorage.getItem('cartId'),
          ...this.props.checkout,
        };

        // GA CHECKOUT OPTION EVENT
        checkoutStepOptionEvent(4, this.props.checkout.paymentType);

        // GTM ADD PAYMENT INFO
        if (this.props.hasGoogleTagManager) {
          gtmToGa4AddPaymentInfo(
            this.props.cart,
            this.props.cartTotalWithExpenses,
            {
              type: this.props.checkout.paymentType,
              cost: this.props.checkout.paymentCost,
            }
          );
        }

        // GA4 ADD PAYMENT INFO
        if (this.props.hasGoogleAnalytics4Advanced) {
          ga4AddPaymentInfo(this.props.cart, this.props.cartTotalWithExpenses, {
            type: this.props.checkout.paymentType,
            cost: this.props.checkout.paymentCost,
          });
        }

        // FKMX ADD PAYMENT INFO
        if (this.props.hasFarmakomMetrics) {
          fkmxAddPaymentInfo(
            this.props.cart,
            this.props.cartTotalWithExpenses,
            {
              type: this.props.checkout.paymentType,
              cost: this.props.checkout.paymentCost,
            }
          );
        }

        const orderToSend = {
          cartId: order.cartId,
          shipping: order.shipping,
          billing: order.billing,
          couponCode: order.coupon.code,
          paymentType: order.paymentType,
          shippingType: order.shippingType,
          slotHour: order.slotHour,
          isInvoiceRequested: !!order.isInvoiceRequested,
          pickupAtPharmacy: !!order.pickupAtPharmacy,
          ricetta: order.ricetta,
          isGreenPackage: !!order.isGreenPackage,
          medium: order.medium || null,
          source: order.source || null,
          firstProductId: sessionStorage.getItem('firstProductId') || null,
        };

        if (order.guestCheckout) {
          orderToSend.user = order.user;
        }

        // if (!!order.pickupLocation && order.pickupLocation.id !== 'store_address') {
        if (!!order.pickupLocation) {
          orderToSend.pickupLocation = order.pickupLocation;
          delete orderToSend.pickupLocation.id;
          delete orderToSend.pickupLocation.storeId;
          delete orderToSend.pickupLocation.createdAt;
        }

        delete orderToSend.pudo;

        return orderToSend;
      };

      async function createOrderCallback() {
        resultMessage('');
        document
          .getElementById('card-field-submit-button')
          .classList.add('loader');
        document.getElementById('card-field-submit-button').style['height'] =
          '3rem';
        document.getElementById('card-field-submit-button').style['width'] =
          '3rem';
        document.getElementById('card-field-submit-button').style['display'] =
          'flex';
        document.getElementById('paypal-button-container').style['display'] =
          'none';
        document.getElementById('card-name-field-container').style['display'] =
          'none';
        document.getElementById('card-number-field-container').style[
          'display'
        ] = 'none';
        document.getElementById('card-expiry-field-container').style[
          'display'
        ] = 'none';
        document.getElementById('card-cvv-field-container').style['display'] =
          'none';
        document.getElementById('paypal-divider').style['display'] = 'none';
        try {
          const order = prepareOrder();
          const data = {
            ...order,
            paymentType: 'paypal_advanced',
          };

          // first we create the order in our db
          const responseOrder = await fetch(`${apiUrl}/orders`, {
            method: 'post',
            headers: {
              storeid: storeId,
              ...JSON.parse(headers),
            },
            body: JSON.stringify(data),
          });
          const newOrderData = await responseOrder.json();
          console.log('new order data - ', newOrderData);

          if (newOrderData && newOrderData.id) {
            // if the order is created successfully, we can create the payment in paypal
            const response = await fetch(
              apiUrl.replace('/v1', '/v2') + '/payments/paypal/advanced/create',
              {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  storeid: storeId,
                  ...JSON.parse(headers),
                },
                body: JSON.stringify({
                  orderId: newOrderData.id,
                }),
              }
            );

            const orderData = await response.json();

            if (orderData.id) {
              return orderData.id;
            } else {
              const errorDetail = orderData?.details?.[0];
              const errorMessage = errorDetail
                ? `${errorDetail.issue} ${errorDetail.description} (${orderData.debug_id})`
                : JSON.stringify(orderData);
              resultMessage(errorMessage);
            }
          } else {
            resultMessage("Errore generico durante la creazione dell'ordine");
          }
        } catch (error) {
          console.error(error);
          resultMessage(
            `Errore durante la creazione dell'ordine...<br><br>${error}`
          );
        }
      }

      async function onApproveCallback(data, actions) {
        try {
          const responseCapture = await fetch(
            apiUrl.replace('/v1', '/v2') + '/payments/paypal/advanced/capture',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                storeid: storeId,
                ...JSON.parse(headers),
              },
              body: JSON.stringify({
                transactionNumber: data.orderID,
              }),
            }
          );
          const captureData = await responseCapture.json();

          if (captureData && captureData.redirectUrl) {
            window.location.href = captureData.redirectUrl;
          } else {
            resultMessage("Errore durante la creazione dell'ordine");
            window.location.href = '/checkout-failure';
          }
        } catch (error) {
          console.error(error);
          resultMessage(
            `Sorry, your transaction could not be processed...<br><br>${error}`
          );
          window.location.href = '/checkout-failure';
        }
      }

      async function onCancelCallback(data) {
        document
          .getElementById('card-field-submit-button')
          .classList.remove('loader');
        document.getElementById('card-field-submit-button').style['height'] =
          'unset';
        document.getElementById('card-field-submit-button').style['width'] =
          'unset';
        document.getElementById('card-field-submit-button').style['display'] =
          'flex';
        document.getElementById('paypal-button-container').style['display'] =
          'flex';
        document.getElementById('card-name-field-container').style['display'] =
          'flex';
        document.getElementById('card-number-field-container').style[
          'display'
        ] = 'flex';
        document.getElementById('card-expiry-field-container').style[
          'display'
        ] = 'flex';
        document.getElementById('card-cvv-field-container').style['display'] =
          'flex';
        document.getElementById('paypal-divider').style['display'] = 'flex';

        try {
          await fetch(
            apiUrl.replace('/v1', '/v2') + '/payments/paypal/advanced/cancel',
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                storeid: storeId,
                ...JSON.parse(headers),
              },
              body: JSON.stringify({
                transactionNumber: data.orderID,
              }),
            }
          );
        } catch (error) {
          console.error(error);
        }
      }

      // Example function to show a result to the user. Your site's UI library can be used instead.
      function resultMessage(message) {
        const container = document.querySelector('#result-message');
        container.innerHTML = message;
      }
    } else {
      console.error('Paypal script not loaded');
    }
  };

  loadPaypalPayIn3Script = () => {
    const { cartTotalWithExpenses, user, storeId, checkout } = this.props;

    // 1 - check if the script is already loaded
    if (!!document.getElementById('paypal_pay_in_3_script')) {
      // 2 - if it is, remove it
      document.getElementById('paypal_pay_in_3_script').remove();
    }

    const scriptPaypalPayIn3 = document.createElement('script');
    scriptPaypalPayIn3.id = 'paypal_pay_in_3_script';
    scriptPaypalPayIn3.innerHTML = `
      // let orderIdP3;

      var FUNDING_SOURCES = [
        paypal.FUNDING.PAYPAL,
        // paypal.FUNDING.CARD,
      ]

      // Loop over each funding source/payment method
      FUNDING_SOURCES.forEach(function (fundingSource) {
        // Initialize the buttons
        var button = paypal
        .Buttons({
          fundingSource: fundingSource,
          style: {
            layout: "horizontal",
          },
          createOrder: function (data, actions) {
            console.log("createOrder", data, actions);
            return actions.order.create({
              purchase_units: [
                {
                  amount: {
                    value: "${cartTotalWithExpenses.toFixed(2)}"
                  },
                },
              ],
            });
          },
          onApprove: function (createData, actions) {
            document.getElementById("paypal-button-container-pay-in-3").classList.add("loader");
            document.getElementById("paypal-button-container-pay-in-3").style["width"] = "4em";
            document.getElementById("paypal-button-container-pay-in-3").style["margin-bottom"] = "2rem";

            window.orderIdP3 = createData.orderID;

            console.log("paypal button - paypal order created - now capturing");

            const order = '${JSON.stringify(this.prepareOrder())}';
            const data = {
              ...JSON.parse(order),
              paymentType: "paypal_advanced",
              transactionId: window.orderIdP3,
            };
            console.log("data", data);
            
            const headers = '${
              checkout.guestCheckout
                ? JSON.stringify(getHeaders(true))
                : JSON.stringify(getAuthHeaders())
            }';

            fetch("${apiUrl}/orders", {
              method: "post",
              headers: {
                storeid: ${storeId},
                ...JSON.parse(headers),
              },
              body: JSON.stringify(data),
            })
              .then(function (res) {
                return res.json();
              })
              .then(function (orderData) {
                // se non c'è orderData.id vuol dire che è fallita la creazione dell'ordine
                if (orderData && orderData.id) {
                  // procedo ad incassare il pagamento e gestisco la risposta da api
                  const data = {
                    orderId: orderData.id
                  };
                  fetch("${apiUrl}/payments/paypal/advanced/capture", {
                    method: "POST",
                    headers: {
                      ${
                        !!localStorage.getItem('token')
                          ? `"Authorization": "Bearer ${localStorage.getItem(
                              'token'
                            )}",`
                          : ''
                      }
                      "storeid": ${storeId},
                    },
                    body: JSON.stringify(data),
                  })
                    .then(function (res) {
                      return res.json();
                    })
                    .then(function (data) {
                      console.log("data", data);
                      window.location.href = data.redirectUrl;
                    })
                    .catch(function (err) {
                      console.log("Error capturing payment", err);
                      window.location.href = "/checkout-failure";
                    })
                } else {
                  console.log("Order not created", err);
                  window.location.href = "/checkout-failure";
                }
              });
          },
        })
        
        // Check if the button is eligible
        if (button.isEligible()) {
          // Render the standalone button for that funding source
          button.render('#paypal-button-container-pay-in-3')
        }
      })
    `;

    setTimeout(() => {
      document.body.appendChild(scriptPaypalPayIn3);
    }, 500);
  };

  setPaymentType = (type, cost) => event => {
    this.props.setPaymentType(type, cost);
  };

  saveOrder = event => {
    const order = {
      cartId: localStorage.getItem('cartId'),
      ...this.props.checkout,
    };

    this.setState({
      savingOrder: true,
    });

    // GA CHECKOUT OPTION EVENT
    checkoutStepOptionEvent(4, this.props.checkout.paymentType);

    // GTM ADD PAYMENT INFO
    if (this.props.hasGoogleTagManager) {
      gtmToGa4AddPaymentInfo(
        this.props.cart,
        this.props.cartTotalWithExpenses,
        {
          type: this.props.checkout.paymentType,
          cost: this.props.checkout.paymentCost,
        }
      );
    }

    // GA4 ADD PAYMENT INFO
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4AddPaymentInfo(this.props.cart, this.props.cartTotalWithExpenses, {
        type: this.props.checkout.paymentType,
        cost: this.props.checkout.paymentCost,
      });
    }

    // FKMX ADD PAYMENT INFO
    if (this.props.hasFarmakomMetrics) {
      fkmxAddPaymentInfo(this.props.cart, this.props.cartTotalWithExpenses, {
        type: this.props.checkout.paymentType,
        cost: this.props.checkout.paymentCost,
      });
    }

    this.props.createOrder(order);
  };

  prepareOrder = event => {
    const order = {
      cartId: localStorage.getItem('cartId'),
      ...this.props.checkout,
    };

    // GA CHECKOUT OPTION EVENT
    checkoutStepOptionEvent(4, this.props.checkout.paymentType);

    // GTM ADD PAYMENT INFO
    if (this.props.hasGoogleTagManager) {
      gtmToGa4AddPaymentInfo(
        this.props.cart,
        this.props.cartTotalWithExpenses,
        {
          type: this.props.checkout.paymentType,
          cost: this.props.checkout.paymentCost,
        }
      );
    }

    // GA4 ADD PAYMENT INFO
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4AddPaymentInfo(this.props.cart, this.props.cartTotalWithExpenses, {
        type: this.props.checkout.paymentType,
        cost: this.props.checkout.paymentCost,
      });
    }

    // FKMX ADD PAYMENT INFO
    if (this.props.hasFarmakomMetrics) {
      fkmxAddPaymentInfo(this.props.cart, this.props.cartTotalWithExpenses, {
        type: this.props.checkout.paymentType,
        cost: this.props.checkout.paymentCost,
      });
    }

    const orderToSend = {
      cartId: order.cartId,
      shipping: order.shipping,
      billing: order.billing,
      couponCode: order.coupon.code,
      paymentType: order.paymentType,
      shippingType: order.shippingType,
      slotHour: order.slotHour,
      isInvoiceRequested: !!order.isInvoiceRequested,
      pickupAtPharmacy: !!order.pickupAtPharmacy,
      ricetta: order.ricetta,
      isGreenPackage: !!order.isGreenPackage,
      medium: order.medium || null,
      source: order.source || null,
      firstProductId: sessionStorage.getItem('firstProductId') || null,
    };

    if (order.guestCheckout) {
      orderToSend.user = order.user;
    }

    // if (!!order.pickupLocation && order.pickupLocation.id !== 'store_address') {
    if (!!order.pickupLocation) {
      orderToSend.pickupLocation = order.pickupLocation;
      delete orderToSend.pickupLocation.id;
      delete orderToSend.pickupLocation.storeId;
      delete orderToSend.pickupLocation.createdAt;
    }

    delete orderToSend.pudo;

    return orderToSend;
  };

  renderTotalButtons = isMobile => {
    const { paymentType, pickupAtPharmacy } = this.props.checkout;
    const { primaryColor, cartTotalWithExpenses, uiVariantButton } = this.props;
    const { savingOrder } = this.state;

    return (
      <div
        className={`total-buttons ${isMobile ? 'mobile' : 'desktop'}`}
        style={{
          backgroundColor: isMobile ? primaryColor : 'transparent',
        }}
      >
        {!isMobile && <hr className="total-line" />}

        <div className="total">
          <span className="text">Totale da pagare:</span>
          <span className="amount">
            <Price amount={cartTotalWithExpenses} />
          </span>
        </div>

        <div className="buttons">
          <Button
            type="button"
            onClick={() => {
              if (!!savingOrder) {
                window.location.reload();
              }
              this.props.router.push('/spedizione');
            }}
            className={`btn ${
              isMobile ? 'btn-inverse' : 'btn-outline btn-thick'
            }`}
            style={{
              flex: isMobile ? 1 : 'unset',
              color: isMobile ? '#fff' : primaryColor,
              backgroundColor: isMobile ? primaryColor : 'unset',
              margin: 0,
              border: `1px solid ${isMobile ? '#fff' : primaryColor}`,
            }}
          >
            Indietro
          </Button>
          <Button
            type="button"
            disabled={savingOrder || !paymentType}
            onClick={this.saveOrder}
            className={`btn ${
              isMobile ? 'btn-inverse' : 'btn-primary btn-thick'
            }`}
            style={{
              flex: isMobile ? 1 : 'unset',
              color: isMobile ? primaryColor : '#fff',
              backgroundColor: isMobile ? '#fff' : primaryColor,
              margin: 0,
            }}
          >
            {savingOrder && <FaSpinner className="pulse" />}
            Conferma e procedi
          </Button>
        </div>
      </div>
    );
  };

  calcRowsPaymentTypes = () => {
    const { pickupAtPharmacy, shippingType } = this.props.checkout;
    const pudoId = this.props.checkout.shipping.pudoId;
    const { allowCashOnDelivery } = this.props;

    let num = 0;
    if (this.props.hasNexi) {
      num += 1;
    }
    if (this.props.hasPaypal && !this.state.withRicetta) {
      num += 1;
    }
    if (this.props.hasPaypalAdvanced && !this.state.withRicetta) {
      num += 1;
    }
    if (this.props.hasSatispay && !this.state.withRicetta) {
      num += 1;
    }
    if (shippingType === 'ESPRESSO') {
      num += 1;
    }
    if (!pickupAtPharmacy && !pudoId && allowCashOnDelivery) {
      num += 1;
    }

    const rows = num === 4 || num === 2 ? 2 : 3;

    return rows;
  };

  renderPaymentType = (type, title, subtitle, price) => {
    const { paymentType } = this.props.checkout;
    const { primaryColor, uiVariantButton, isMobile } = this.props;
    const isActive = paymentType === type;
    const pagamentoStyle = css`
      {
        border-radius: ${
          uiVariantButton === '1' ? '8px' : uiVariantButton === '3' ? '12px' : 0
        };
        border-color: ${primaryColor};
        &.active {
            background-color: ${primaryColor}!important;
          }
        }
      }
    `;

    const renderRadioIdByType = type => {
      switch (type) {
        case 'credit_card':
          return 'credit-card';
        case 'bonifico':
          return 'bank';
        case 'contrassegno':
          return 'cod';
        case 'satispay':
          return 'sat';
        case 'nexi':
          return 'nexi';
        case 'paypal':
          return 'paypal';
        default:
          return '';
      }
    };

    const renderIcon = type => {
      switch (type) {
        case 'nexi':
          return <CarteNexiOneLine style={{ height: 24, marginLeft: 16 }} />;
        default:
          return null;
      }
    };

    return (
      <div
        className={`payment-type-box ${isActive ? 'active' : ''}`}
        onClick={this.setPaymentType(type, price)}
        css={pagamentoStyle}
        style={{
          flexDirection: 'row',
          margin: '0 8px 16px',
        }}
      >
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            textAlign: 'left',
            flex: 2,
          }}
        >
          <div
            className="title-price"
            style={{
              alignItems: 'flex-start',
              width: 'fit-content',
            }}
          >
            <div className="payment-title" style={{ fontWeight: 'bold' }}>
              {title}
            </div>
            {subtitle && (
              <div className="payment-subtitle" style={{ margin: 0 }}>
                {subtitle}
              </div>
            )}
          </div>
          {!isMobile && renderIcon(type)}
        </div>

        <div
          className="radio-icon"
          style={{ flexDirection: 'row', alignItems: 'center', flex: 1 }}
        >
          <div
            className="title-price"
            style={{
              marginRight: 8,
              alignItems: isMobile ? 'center' : 'flex-end',
              justifyContent: isMobile ? 'flex-end' : 'center',
            }}
          >
            <div className="payment-price">
              {price === 0 ? 'Gratis' : <Price amount={price} />}
            </div>
          </div>
          <RadioContainer>
            <input
              type="radio"
              id={renderRadioIdByType(type)}
              name="paymentType"
              checked={isActive}
              readOnly
            />
            <label htmlFor={renderRadioIdByType(type)} />
          </RadioContainer>
        </div>
      </div>
    );
  };

  render() {
    const { pickupAtPharmacy, shippingType, paymentType } = this.props.checkout;
    const pudoId = this.props.checkout.shipping.pudoId;
    const { allowCashOnDelivery, primaryColor, isMobile } = this.props;
    const { paypalBoxHeight } = this.state;

    const paymentStyle = css`
      .loader {
        border-left: 0.5em solid ${primaryColor};
        border-radius: 50% !important;
      }
    `;
    return (
      <div className="pagamento" style={{ minWidth: '64%' }} css={paymentStyle}>
        <div
          className="payment-methods"
          // style={{ flexWrap: 'wrap', justifyContent: 'flex-start' }}
          style={{ flexDirection: 'column' }}
        >
          {this.props.hasNexi &&
            this.renderPaymentType(
              'nexi',
              this.props.hasPaypal ||
                this.props.hasPaypalAdvanced ||
                !this.props.hasPaypalInNexi
                ? 'Carta di credito'
                : 'Carta di credito / PayPal',
              this.state.withRicetta
                ? 'La somma effettiva sarà addebitata solo dopo la verifica delle detrazioni fiscali spettanti da parte del farmacista in base alla tua ricetta.'
                : '',
              0
            )}

          {this.props.hasPaypal &&
            !this.state.withRicetta &&
            this.renderPaymentType(
              'paypal',
              this.props.hasNexi ? 'PayPal' : 'Carta di credito / PayPal',
              '',
              0
            )}

          {this.props.hasPaypalAdvanced &&
            !this.state.withRicetta &&
            this.renderPaymentType(
              'paypal_advanced',
              this.props.hasNexi ? 'PayPal' : 'Carta di credito / PayPal',
              '',
              0
            )}

          <div
            style={{
              height: paymentType !== 'paypal_advanced' ? 0 : 'unset',
              overflow: 'hidden',
              transition: '0.25s ease-in-out',
            }}
          >
            <div
              id="payload_advanced_box"
              className="paypal"
              style={{ padding: '16px 8px 16px' }}
            >
              {/* Containers for Card Fields hosted by PayPal */}
              <div
                id="paypal-button-container"
                class="paypal-button-container"
              ></div>
              <div id="paypal-divider" className="divider">
                <span>OR</span>
              </div>
              <div id="card-form" class="card_container">
                <div id="card-name-field-container"></div>
                <div id="card-number-field-container"></div>
                <div id="card-expiry-field-container"></div>
                <div id="card-cvv-field-container"></div>
                <button id="card-field-submit-button" type="button">
                  Paga ora
                </button>
              </div>
              <p id="result-message"></p>
            </div>
          </div>

          {/* PAYPAL PAGA IN 3 RATE */}
          {this.props.hasPaypalPayIn3 &&
            !this.state.withRicetta &&
            this.renderPaymentType(
              'paypal_pay_in_3',
              'Paga in 3 rate con Paypal',
              '',
              0
            )}

          <div
            style={{
              height: paymentType !== 'paypal_pay_in_3' ? 0 : 150,
              overflow: 'hidden',
              transition: '0.25s ease-in-out',
            }}
          >
            <div
              id="payload_advanced_box"
              className="paypal"
              style={{ padding: '16px 8px 16px' }}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                }}
              >
                <div
                  style={{ width: '40%' }}
                  id="paypal-button-container-pay-in-3"
                ></div>
                <div id="pp-pay-later-message"></div>
              </div>
            </div>
          </div>

          {this.props.hasSatispay &&
            !this.state.withRicetta &&
            this.renderPaymentType('satispay', 'Satispay', '', 0)}

          {!pickupAtPharmacy &&
            !pudoId &&
            allowCashOnDelivery &&
            this.renderPaymentType(
              'contrassegno',
              'Contrassegno al corriere',
              this.state.withRicetta
                ? 'La somma effettiva sarà calcolata solo dopo la verifica delle detrazioni fiscali spettanti da parte del farmacista in base alla tua ricetta.'
                : '',
              this.props.costiSpedizione.priceCashIsRate
                ? Math.round(
                    ((this.props.cartTotal * this.props.importoContrassegno) /
                      100 +
                      Number.EPSILON) *
                      100
                  ) / 100
                : this.props.importoContrassegno
            )}

          {shippingType === 'ESPRESSO' &&
            !!this.props.bankAccount &&
            this.props.bankAccount !== '' &&
            !this.props.disableBankTransferPayment &&
            this.renderPaymentType(
              'bonifico',
              'Bonifico Bancario',
              "L'ordine sarà lavorato alla ricezione del bonifico",
              0
            )}
        </div>

        {paymentType !== 'paypal_advanced' &&
          paymentType !== 'paypal_pay_in_3' &&
          this.renderTotalButtons(this.props.isMobile)}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isMobile: state.layout.isMobile,
  storeId: state.store.data.id || state.store.data.storeId,
  checkout: state.checkout,
  user: state.user,
  cart: state.cart,
  costiSpedizione: state.store.data.costiSpedizione,
  bankAccount: state.store.data.datiFarmacia.bankAccount,
  disableBankTransferPayment:
    state.store.data.funzionalita.disableBankTransferPayment,
  allowCashOnDelivery: state.store.data.costiSpedizione.allowCashOnDelivery,
  importoContrassegno: state.store.data.costiSpedizione.priceCashondelivery,
  cartTotal: getCartTotalDiscountedCoupon(state),
  cartTotalWithExpenses: getCartTotalWithExpenses(state),
  advancedGa: state.store.data.features.advancedGa,
  hasSatispay: state.store.data.features.hasSatispay,
  hasNexi: state.store.data.features.hasNexi,
  hasPaypal: state.store.data.features.hasPaypal,
  hasPaypalAdvanced: state.store.data.features.hasPaypalAdvanced,
  hasPaypalPayIn3: state.store.data.features.hasPaypalPayIn3,
  primaryColor: state.store.data.loghiTemplate.brandColor,
  uiVariantButton: state.store.data.uiVariants.buttons,
  hasGoogleAnalytics4Advanced: !!state.store.data.features
    .hasGoogleAnalytics4Advanced,
  hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
  hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  hasPaypalInNexi: !!state.store.data.integrazioni.nexi.hasPaypal,
  paypalConfig: state.store.data.integrazioni.paypal,
  allowPremiumShipping: state.store.data.costiSpedizione.allowPremiumShipping,
  greenPackageCost: state.store.data.costiSpedizione.packagingGreenPrice,
});

Pagamento = connect(mapStateToProps, { setPaymentType, createOrder })(
  Pagamento
);
Pagamento = withRouter(Pagamento);

export default Pagamento;
